<template>
  <div>
    <app-header><cp-nav></cp-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Painel de Controlo</h2>
      </div>
      <p>Painel de administração da prova...</p>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import CpNav from './Nav.vue'

export default {
  name: 'CpPainel',
  components: {
    AppHeader,
    CpNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Painel.vue?0633239e